import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const TrendSVG = styled.svg`
	width: 14px;
	height: 20px;

	.trend,
	.trend-1,
	.trend-2,
	.trend-3 {
		fill: #a2a9ad;
	}
`;

export const TrendSelector = props => {
	const { id, theme, module, position, className } = props;
	const rotate = position === 'left' ? 'rotate(90)' : 'rotate(270)';
	return (
		<TrendSVG
			id={id}
			module={module}
			x='0px'
			y='0px'
			viewBox='0 0 512 512'
			height='512'
			width='512'
			//style='enable-background:new 0 0 512 512;'
		>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform={rotate}
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<g>
				<path
					class={className}
					d='m512 482h-30v-302h-91v302h-30v-182h-90v182h-30v-242h-90v242h-30v-152h-91v152h-30v30h512z'
				/>
				<path
					class={className}
					d='m512 120v-120h-121v30h69.789l-144.789 143.789-120-120-191.605 190.606 21.21 21.21 170.395-169.394 120 120 166-165v68.789z'
				/>
			</g>
		</TrendSVG>
	);
};
